export default [
  {
    path: 'course-selection-list',
    name: 'tzy_university_course_selection',
    component: () => import('../views/course-selection/List.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '选课',
    },
  },
  {
    path: 'course-selection-form',
    name: 'tzy_university_course_form',
    component: () => import('../views/course-selection/SelectTeacher.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '选择老师',
    },
  },
]
